export const statusColorCode = [
    {
        label: "pending",
        colorBg: "bg-[#F3CBA9]",
        colorText: "text-[#DE6F0D]"
    },
    {
        label: "accepted",
        colorBg: "bg-[#D9F4D4]",
        colorText: "text-[#039855]"
    },
    {
        label: "rejected",
        colorBg: "bg-[#FEDFDD]",
        colorText: "text-[#D92D20]"
    },
    
]